import {schedulerState} from "./calendar"
import {storeProTypeID} from "./storeProTypeID";
import {progressBarDisplay} from "./progressBarDisplay";


$(document).off().on("click", "#schedulerWizard #service-search-page a.pointer.js-next-btn", function(e:any){
    e.preventDefault();
    schedulerState.numberOfSlot = 1;
    //var serviceName =  e.currentTarget.querySelector('a');
    var serviceName = $(this).text();
    $('#warrantyDetails input[name="serviceListQuery"]').val(serviceName);
    var serviceSkuId = e.target.id;
    var serviceId = e.currentTarget.id
    window.objOSGlobal.requestBodyValues.serviceSkuId = serviceSkuId;
    window.objOSGlobal.requestBodyValues.ServiceId = serviceId;
    window.objOSGlobal.requestBodyValues.ServiceSkuIds = [serviceSkuId];
    window.objOSGlobal.requestBodyValues.serviceName = serviceName;
    storeProTypeID(serviceSkuId);
    progressBarDisplay()
});

$('.scheduler-modal .modal-dialog .modal-content').on('click',function(){
    $('.services-list-dd').hide();
});